import { useEffect, useState } from "react";
import { Star } from "lucide-react";
import api from "@/lib/api";
import { Reveal } from "@/components/store/Reveal";

export default function Reviews() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/testimonials").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  return (
    <div className="pt-28 md:pt-36 pb-24" data-testid="reviews-page">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <Reveal>
          <p className="overline text-terracotta mb-3">Proof, not promises</p>
          <h1 className="font-serif text-5xl md:text-7xl text-espresso tracking-tight mb-4">Real results</h1>
          <p className="text-bark max-w-xl mb-14">
            Glowing skin, even tone, and renewed confidence — straight from our community.
          </p>
        </Reveal>

        <div className="columns-1 md:columns-2 lg:columns-3 gap-6 space-y-6">
          {items.map((r, i) => (
            <Reveal key={r.id} delay={(i % 3) * 0.08}>
              <div className="break-inside-avoid bg-sand rounded-2xl p-7" data-testid={`review-${r.id}`}>
                <div className="flex gap-0.5 text-terracotta mb-4">
                  {Array.from({ length: r.rating || 5 }).map((_, k) => (
                    <Star key={k} className="w-4 h-4 fill-current" />
                  ))}
                </div>
                <p className="font-serif text-xl text-espresso leading-snug mb-6">“{r.text}”</p>
                <div className="flex items-center gap-3">
                  {r.photo ? (
                    <img src={r.photo} alt={r.name} className="w-10 h-10 rounded-full object-cover" />
                  ) : (
                    <div className="w-10 h-10 rounded-full bg-terracotta/15 text-terracotta flex items-center justify-center font-serif">
                      {r.name?.[0]}
                    </div>
                  )}
                  <span className="overline text-bark">{r.name}</span>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
}
